/**
 * I passi del tutorial guidato di Import da marchi.
 *
 * Un solo preparativo: se nessuna marca e' scelta si apre la prima dell'elenco (senza,
 * pannello e tabella non esistono). La marca scelta resta: e' la pagina su cui l'utente
 * sta lavorando.
 *
 * Tutti i bersagli sono dentro la pagina: nessun menu di Vuetify da aprire.
 */
const at = name => `[data-tour-scope="brand-import"] [data-tour="${name}"]`;

const PRIMA_MARCA = `${at('brand-list')} .v-list-item`;

function presente(selector) {
	const el = document.querySelector(selector);
	return !!el && el.getClientRects().length > 0;
}

async function aspetta(selector, voluto = true, timeout = 1500) {
	const fine = performance.now() + timeout;
	while (performance.now() < fine) {
		if (presente(selector) === voluto) return;
		await new Promise(resolve => setTimeout(resolve, 50));
	}
}

/** Pannello e tabella esistono solo con una marca scelta: se manca si apre la prima. */
async function soloMarca() {
	if (presente(at('brand-panel'))) return;
	const prima = document.querySelector(PRIMA_MARCA);
	if (!prima) return;
	prima.click();
	await aspetta(at('brand-panel'));
}

/** Il menu a tre puntini esiste solo con almeno un prodotto nella tabella. */
async function primaRiga() {
	await soloMarca();
	await aspetta(at('row-menu'), true, 2000);
}

export function createBrandImportTourSteps() {
	return [
		{
			body: "Qui importi i prodotti dal sito ufficiale di una marca: il sistema legge la sitemap, apre le pagine prodotto ed estrae titolo, descrizione, immagini, codici e prezzo. I prodotti non vanno subito in catalogo: restano qui finche' non li approvi tu. Va usato per le marche di cui sei rivenditore autorizzato.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'A cosa serve questa pagina',
		},
		{
			body: "Per usare il servizio serve OpenAI configurato con la tua chiave in Impostazioni > AI: e' quello che scrive le regole con cui vengono letti i siti delle marche. Se vedi questo avviso, parti da li'. Traduzioni e riscritture dei testi invece non usano OpenAI.",
			key: 'openai',
			placement: 'bottom',
			target: at('openai'),
			timeout: 250,
			title: 'Prima di iniziare: OpenAI',
		},
		{
			body: "L'elenco delle marche del catalogo. L'etichetta dice a che punto e' ognuna: da configurare, regole in bozza, regole attive, bloccata dal sito o in corso. Sotto compare quanti prodotti aspettano di essere valutati. Il sito della marca si imposta nella scheda della marca o nelle impostazioni di import. La marca scelta resta nell'indirizzo della pagina: con un refresh o tornando da una scheda la ritrovi.",
			key: 'brand-list',
			placement: 'right',
			target: at('brand-list'),
			title: 'Scegliere la marca',
		},
		{
			body: "Il pannello della marca scelta: il sito, gli avvisi (sito che blocca le richieste, pagine che richiedono la modalita' browser, regole in bozza da confermare) e l'ultima operazione con il suo avanzamento. Le scansioni sono lente di proposito - una pagina ogni pochi secondi - e puoi chiudere la pagina: arriva una notifica alla fine.",
			before: soloMarca,
			key: 'brand-panel',
			placement: 'bottom',
			target: at('brand-panel'),
			timeout: 250,
			title: 'Lo stato della marca',
		},
		{
			body: "Il primo passo con una marca nuova. L'AI studia alcune pagine prodotto del sito e scrive le regole per leggerle - dove stanno titolo, descrizione, galleria, codici. Le regole restano in bozza: le controlli nell'anteprima e le attivi tu. Se il sito cambia aspetto, vengono rigenerate da sole durante la scansione.",
			before: soloMarca,
			key: 'generate',
			placement: 'top',
			target: at('generate'),
			timeout: 250,
			title: 'Generare le regole',
		},
		{
			body: "Apre la pagina delle impostazioni di import della marca: sitemap, filtri sugli indirizzi, lingua delle pagine e modalita' di lettura, e le versioni delle regole: anteprima sulle pagine campione, modifica e attivazione. C'e' anche Tara con un prodotto: apri una pagina della marca e clicchi tu dove stanno titolo, brand, descrizione, immagini, SKU, EAN e prezzo. Le scelte fatte cosi' vincono su quelle dell'AI. Salva impostazioni o Annulla, in basso, ti riportano qui.",
			before: soloMarca,
			key: 'configure',
			placement: 'left',
			target: at('configure'),
			timeout: 250,
			title: 'Impostazioni e taratura',
		},
		{
			body: "Con le regole attive, la scansione legge tutti i prodotti della sitemap e li porta qui sotto. Una seconda scansione aggiorna solo quello che e' cambiato sul sito: i prodotti invariati non si toccano.",
			before: soloMarca,
			key: 'scan',
			placement: 'top',
			target: at('scan'),
			timeout: 250,
			title: 'Scansionare il sito',
		},
		{
			body: "I prodotti trovati, divisi per stato: da valutare, in importazione, importati, scartati e in errore. Il numero accanto a ogni scheda dice quanti sono.",
			before: soloMarca,
			key: 'products-tabs',
			placement: 'bottom',
			target: at('products-tabs'),
			timeout: 250,
			title: 'I prodotti trovati',
		},
		{
			body: "Cerca per nome, SKU o EAN. L'interruttore mostra solo i prodotti che hanno lo stesso EAN o SKU di uno gia' presente nel tuo catalogo, per evitare doppioni.",
			before: soloMarca,
			key: 'products-search',
			placement: 'bottom',
			target: at('products-search'),
			timeout: 250,
			title: 'Cercare e trovare i doppioni',
		},
		{
			body: "Importa tutti porta nel catalogo, in un colpo solo, i prodotti che la lista sta mostrando con scheda, ricerca e interruttore attuali (fino a 500 per volta: poi si ripete). Si scelgono categorie e IVA come per il singolo prodotto. Compare solo nelle schede con prodotti ancora da importare.",
			before: soloMarca,
			key: 'approve-filtered',
			placement: 'left',
			target: at('approve-filtered'),
			timeout: 250,
			title: 'Importare in blocco',
		},
		{
			body: "Le etichette sulla riga dicono cosa c'e' da fare: Da completare (il sito non riporta SKU, EAN o prezzo), Da tradurre (pagine in un'altra lingua), Gia' in catalogo, Cambiato sul sito. Scheda, ricerca e pagina restano nell'indirizzo: tornando da un prodotto ritrovi la lista com'era.",
			before: soloMarca,
			key: 'products-table',
			placement: 'top',
			target: at('products-table'),
			timeout: 250,
			title: 'Leggere la tabella',
		},
		{
			body: "Dai tre puntini a sinistra di ogni prodotto: Apri e modifica (testi originali, tradotti e riscritti affiancati, codici e prezzo da completare, immagini da ingrandire o togliere), Approva e importa (lo crea nel catalogo - disattivo, con giacenza 0 - e solo allora copia le immagini su S3; prima chiede categorie e IVA), Scarta, Traduci e Riscrivi testi (lavorano sul computer dello scraping, circa un minuto a prodotto), Ripristina per gli scartati e Riscansiona, che chiede conferma prima di riscaricare il prodotto dal sito.",
			before: primaRiga,
			key: 'row-menu',
			missing: 'skip',
			placement: 'right',
			target: at('row-menu'),
			timeout: 250,
			title: 'Le azioni sul prodotto',
		},
	];
}
